export const initNavigatedContentBlock = ( el: HTMLElement ) => {
	const Object = {
		config: {
			offset: 114,
		},
		container: el,
		headerEl: el.querySelector('.wv-navigated-content-header') as HTMLElement,
		navigationEl: el.querySelector('.wv-navigated-content__navigation') as HTMLElement,
		navigationListEl: el.querySelector('.wv-navigated-content__navigation-list') as HTMLElement,
		sections: el.querySelectorAll( '.wv-navigated-content-section' ) as NodeListOf<HTMLElement>,

		_init(): void {
			console.log( 'Init Navigated Content: ', this.container, this.sections );

			this._bindClass();
			this._bindEvents();
			this.setupNavigatedContent();
			this.handleNavigatedContent();
		},

		_bindClass(): void {
			this.handleNavigatedContent = this.handleNavigatedContent.bind(this);
			this.scrollToSection = this.scrollToSection.bind(this);
			this.setupNavigatedContent = this.setupNavigatedContent.bind(this);
			this.toggleActiveLink = this.toggleActiveLink.bind(this);
		},

		_bindEvents(): void {
			window.addEventListener( 'scroll', this.handleNavigatedContent );
		},

		handleNavigatedContent(): void {
			const top: number    = this.container.getBoundingClientRect().top ?? 0;
			const bottom: number = this.container.getBoundingClientRect().bottom ?? 0;

			// Stick to the center
			if (top <= this.config.offset && bottom > window.innerHeight) {
				this.container.classList.add(`wv-navigated-content--sticky-center`);
				this.container.classList.remove(`wv-navigated-content--sticky-end`);
			}
			// Stick to the end
			else if (bottom <= window.innerHeight) {
				this.container.classList.add(`wv-navigated-content--sticky-end`);
				this.container.classList.remove(`wv-navigated-content--sticky-center`);
			}
			// Stick to the top
			else {
				this.container.classList.remove(`wv-navigated-content--sticky-center`);
				this.container.classList.remove(`wv-navigated-content--sticky-end`);
			}

			this.sections.forEach((section: HTMLElement): void => {
				const sectionTop = section.getBoundingClientRect().top;
				const sectionBottom = section.getBoundingClientRect().bottom;
				const point = window.innerHeight / 2;

				if (sectionTop <= point && sectionBottom > point) {
					const id = section.dataset.sectionId ?? '';
					const link = this.container.querySelector(`.wv-navigated-content__navigation-link[href="#${id}"]`) as HTMLAnchorElement;

					this.toggleActiveLink(link);
				}
			});
		},

		scrollToSection( event: Event ): void {
			event.preventDefault();

			const target: HTMLAnchorElement = event.currentTarget as HTMLAnchorElement;
			const href = target.href;

			const sectionId = href.split('#')[1];
			const sectionEl = this.container.querySelector(`.wv-navigated-content-section[data-section-id="${sectionId}"]`) as HTMLDivElement;

			console.log( sectionId, sectionEl );

			if (sectionEl) {
				const sectionTop = sectionEl.getBoundingClientRect().top + window.pageYOffset - 100;

				this.toggleActiveLink(target);

				window.scrollTo({
					top: sectionTop - this.config.offset,
					behavior: 'smooth'
				});
			}
		},

		setupNavigatedContent(): void {
			this.sections.forEach((section: HTMLElement): void => {
				const id: string = section.dataset.sectionId ?? 'asd';
				const icon: string = section.dataset.sectionIcon ?? 'asd';
				const title: string = section.dataset.sectionTitle ?? 'Section Title';

				const anchorEl: HTMLAnchorElement = document.createElement('a');
				anchorEl.classList.add('wv-navigated-content__navigation-link')
				anchorEl.href = `#${id}`;
				anchorEl.title = title;
				anchorEl.innerHTML = icon;
				anchorEl.addEventListener('click', this.scrollToSection );

				const listItemEl: HTMLLIElement = document.createElement('li');
				listItemEl.classList.add('wv-navigated-content__navigation-list-item');

				listItemEl.append(anchorEl);
				this.navigationListEl?.append(listItemEl);
			});

			const firstAnchorEL: HTMLAnchorElement = this.navigationListEl?.querySelector('.wv-navigated-content__navigation-link') as HTMLAnchorElement;
			this.toggleActiveLink(firstAnchorEL);
		},

		toggleActiveLink(link: HTMLAnchorElement): void {
			const links = this.container.querySelectorAll('.wv-navigated-content__navigation-link') as NodeListOf<HTMLAnchorElement>;
			links.forEach((link: HTMLAnchorElement): void => {
				link.classList.remove('wv-navigated-content__navigation-link--is-active');
			});

			link.classList.add('wv-navigated-content__navigation-link--is-active');
		}
	};

	Object._init();
	return Object;
};

export const initNavigatedContentBlocks = ( selectors = '.wv-navigated-content' ): void => {
	const blocks = document.querySelectorAll( selectors ) as NodeListOf<HTMLElement>;

	blocks.forEach(
		( el: HTMLElement ) => initNavigatedContentBlock( el )
	);
};
